var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { searchProductPacks, validateProductPackSelection } from '../Async/MedicationsSummaryAsync';
import { Button, ButtonMode, ButtonVariant } from '../Components/Button';
import { SidePanelSizes } from '../Components/Dialog/DialogSidebar';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { CloseIcon } from '../Components/Icons';
import { useMedicationSettings } from '../Config/MedicationConfig';
import { MedicationValidation, MedicinalProductSearchBy } from '../Contracts/MedicationModels';
import { DecisionSupportWarningAlert } from '../DecisionSupportWarningAlert';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { white50 } from '../Styles/Colours';
import { BrandPrescriptionWarningDialog } from './BrandPrescriptionWarningDialog';
import { ComplementaryTherapyOrderDialog } from './ComplementaryTherapyOrderDialog';
import { GenericOnLemiExceptionDialog } from './GenericOnLemiExceptionDialog';
import { GenericOnLmbcExceptionDialog } from './GenericOnLmbcExceptionDialog';
import { MedicationBrowserPacksList } from './MedicationBrowserPacksList';
import styles from './MedicationsBrowserDialog.module.css';
import { MedicationsBrowserFilter, useMedicationsBrowserFilter } from './MedicationsBrowserFilter';
import { AlertBanner, AlertBannerTypes } from '../Components/AlertBanner';
function convertProductPackToChosenMedication(productPack, pbsDetail) {
    return __assign(__assign({}, productPack), { pbsDetail: pbsDetail });
}
export var MedicationsBrowserDialog = function (props) {
    if (props.isComplementaryTherapy)
        return React.createElement(ComplementaryTherapyOrderDialog, __assign({}, props));
    return React.createElement(DrugSelector, __assign({}, props));
};
export var DrugSelector = function (props) {
    var medSettings = useMedicationSettings();
    var httpConfig = useHttpConfig();
    var allowFreeTextMedication = medSettings.settings.allowFreeTextMedication && props.allowFreeTextMedication;
    var _a = __read(useState(null), 2), selectedMedication = _a[0], setSelectedMedication = _a[1];
    var _b = __read(useState(''), 2), freeTextMedicationName = _b[0], setFreeTextMedicationName = _b[1];
    var _c = __read(useState([]), 2), expandedMedicationIds = _c[0], setExpandedMedicationIds = _c[1];
    var _d = __read(useState(false), 2), processing = _d[0], setProcessing = _d[1];
    var _e = __read(useState(null), 2), showBrandPrescriptionWarningDialog = _e[0], setShowBrandPrescriptionWarningDialog = _e[1];
    var _f = __read(useState(null), 2), showGenericOnLemiExceptionDialog = _f[0], setShowGenericOnLemiExceptionDialog = _f[1];
    var _g = __read(useState(null), 2), showGenericOnLmbcExceptionDialog = _g[0], setShowGenericOnLmbcExceptionDialog = _g[1];
    var medicationPacksAsync = useAsync({
        defaultValue: [],
        httpConfig: httpConfig,
        getApi: searchProductPacks
    });
    var medicationPacks = medicationPacksAsync.data;
    var filterState = useMedicationsBrowserFilter(function (filter) {
        var _a;
        setSelectedMedication(null);
        setExpandedMedicationIds([]);
        setFreeTextMedicationName((_a = filter.productName) !== null && _a !== void 0 ? _a : '');
        if (filter.productName === null || filter.productName === '') {
            medicationPacksAsync.reset();
            return Promise.resolve();
        }
        medicationPacksAsync.getApi(filter.productName, filter.limit === 0 ? 0 : filter.limit + 1, filter.medicinalProductSearchBy, filter.showNonTga, filter.showOnlySubsidisedMedications);
    }, props.defaultFilter);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedFreeText, selectedPbsDetail, medicationValidation, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (disableMedicationSelection())
                        return [2 /*return*/];
                    trimmedFreeText = (freeTextMedicationName !== null && freeTextMedicationName !== void 0 ? freeTextMedicationName : '').trim();
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 14, , 15]);
                    setProcessing(true);
                    setShowBrandPrescriptionWarningDialog(null);
                    setShowGenericOnLemiExceptionDialog(null);
                    setShowGenericOnLmbcExceptionDialog(null);
                    if (!(selectedMedication === null && !!props.onSelectFreeTextMedication && trimmedFreeText !== '')) return [3 /*break*/, 3];
                    return [4 /*yield*/, props.onSelectFreeTextMedication(trimmedFreeText)];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 13];
                case 3:
                    if (!(selectedMedication !== null)) return [3 /*break*/, 13];
                    selectedPbsDetail = (_b = (_a = selectedMedication.supportedPaymentArrangement) === null || _a === void 0 ? void 0 : _a.pbsDetail) !== null && _b !== void 0 ? _b : null;
                    return [4 /*yield*/, validateProductPackSelection({
                            productPack: selectedMedication,
                            pbsDetail: selectedPbsDetail
                        })];
                case 4:
                    medicationValidation = _c.sent();
                    if (!(medicationValidation.validationResult === MedicationValidation.BrandPrescriptionWarning)) return [3 /*break*/, 5];
                    setShowBrandPrescriptionWarningDialog(medicationValidation);
                    return [3 /*break*/, 13];
                case 5:
                    if (!(medicationValidation.validationResult === MedicationValidation.GenericOnLemiException)) return [3 /*break*/, 6];
                    setShowGenericOnLemiExceptionDialog(medicationValidation);
                    return [3 /*break*/, 13];
                case 6:
                    if (!(medicationValidation.validationResult === MedicationValidation.GenericOnLmbcException)) return [3 /*break*/, 7];
                    setShowGenericOnLmbcExceptionDialog(medicationValidation);
                    return [3 /*break*/, 13];
                case 7:
                    if (!(medicationValidation.validationResult === MedicationValidation.Valid)) return [3 /*break*/, 12];
                    if (!(medicationValidation.medicinalProductPack !== null)) return [3 /*break*/, 9];
                    return [4 /*yield*/, props.onSelectMedication(medicationValidation.medicinalProductPack)];
                case 8:
                    _c.sent();
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, props.onSelectMedication(__assign(__assign({}, selectedMedication), { pbsDetail: selectedPbsDetail }))];
                case 10:
                    _c.sent();
                    _c.label = 11;
                case 11:
                    setProcessing(false);
                    return [3 /*break*/, 13];
                case 12:
                    setProcessing(false);
                    _c.label = 13;
                case 13: return [3 /*break*/, 15];
                case 14:
                    err_1 = _c.sent();
                    console.error('Uncaught error when selecting medication', err_1);
                    setProcessing(false);
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var disableMedicationSelection = function () {
        // If loading.
        if (processing || medicationPacksAsync.status !== UseAsyncStatus.Loaded)
            return true;
        if (showBrandPrescriptionWarningDialog)
            return true;
        if (showGenericOnLemiExceptionDialog)
            return true;
        if (showGenericOnLmbcExceptionDialog)
            return true;
        // If not free text, then there must be a selected medication.
        if (!allowFreeTextMedication && selectedMedication === null)
            return true;
        // If free text
        if (allowFreeTextMedication) {
            // If there are result from the search, then there must be a selected medication.
            if (medicationPacks !== null && medicationPacks.length > 0 && selectedMedication === null)
                return true;
            // If there is no result from the search, then free text medication name can not empty.
            if (medicationPacks === null || medicationPacks.length === 0)
                if ((freeTextMedicationName !== null && freeTextMedicationName !== void 0 ? freeTextMedicationName : '').trim() === '')
                    return true;
        }
        return false;
    };
    var selectMedication = function (productPack) { return __awaiter(void 0, void 0, void 0, function () {
        var medication, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setProcessing(true);
                    setShowBrandPrescriptionWarningDialog(null);
                    setShowGenericOnLemiExceptionDialog(null);
                    setShowGenericOnLmbcExceptionDialog(null);
                    medication = __assign({}, productPack);
                    return [4 /*yield*/, props.onSelectMedication(medication)];
                case 1:
                    _a.sent();
                    setProcessing(false);
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error('Uncaught error when selecting medication', err_2);
                    setProcessing(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateSearchValues = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            filterState.updateMedicinalProductSearchBy(MedicinalProductSearchBy.TradeProductPackOnly)();
            // Limited to 254 characters since that's the max length we store in the product short name.
            // Any more character could not be found in the shortname and would return no results.
            filterState.updateField('productName')(name.substr(0, 254));
            setShowGenericOnLemiExceptionDialog(null);
            setShowGenericOnLmbcExceptionDialog(null);
            setProcessing(false);
            return [2 /*return*/];
        });
    }); };
    var handleCancelSubDialog = function () {
        setShowBrandPrescriptionWarningDialog(null);
        setShowGenericOnLemiExceptionDialog(null);
        setShowGenericOnLmbcExceptionDialog(null);
        setProcessing(false);
    };
    var prompt = (React.createElement("span", null,
        "Can\u2019t find the medication you\u2019re looking for?",
        React.createElement("span", { className: styles.regulartext },
            " Please email us at",
            React.createElement("a", { href: "mailto:" + medSettings.settings.requestEmail, target: '_top', className: styles.emailtext }, medSettings.settings.requestEmail),
            " ")));
    var actionButtons = [
        React.createElement(AlertBanner, { key: 'alert', classNames: styles.medicationinfo, promptMessage: prompt, promptType: AlertBannerTypes.Prompt, verticalSpace: true }),
        React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 161, key: 'cancel', onClick: props.onCancel, disabled: processing, testId: 'navigation-control-cancel' }, "Cancel"),
        React.createElement(StyledDialogButton, { key: 'save', width: 161, onClick: onSubmit, disabled: disableMedicationSelection(), testId: 'navigation-control-save' }, "Select medication")
    ];
    return (React.createElement(React.Fragment, null,
        showBrandPrescriptionWarningDialog && (React.createElement(BrandPrescriptionWarningDialog, { onCancel: handleCancelSubDialog, onUpdateToGeneric: function () {
                return selectMedication(convertProductPackToChosenMedication(showBrandPrescriptionWarningDialog.medicinalProductPack, showBrandPrescriptionWarningDialog === null || showBrandPrescriptionWarningDialog === void 0 ? void 0 : showBrandPrescriptionWarningDialog.medicinalProductPackPbsDetail));
            }, continueWithBrand: function () {
                return selectMedication(convertProductPackToChosenMedication(showBrandPrescriptionWarningDialog.tradeProductPack, showBrandPrescriptionWarningDialog === null || showBrandPrescriptionWarningDialog === void 0 ? void 0 : showBrandPrescriptionWarningDialog.tradeProductPackPbsDetail));
            }, genericName: showBrandPrescriptionWarningDialog.medicinalProductPack.name })),
        showGenericOnLemiExceptionDialog && (React.createElement(GenericOnLemiExceptionDialog, { onCancel: handleCancelSubDialog, onUpdate: function () { return updateSearchValues(showGenericOnLemiExceptionDialog.medicinalProductPack.name); } })),
        showGenericOnLmbcExceptionDialog && (React.createElement(GenericOnLmbcExceptionDialog, { onCancel: handleCancelSubDialog, onAccept: function () {
                return selectMedication(convertProductPackToChosenMedication(showGenericOnLmbcExceptionDialog.medicinalProductPack, showGenericOnLmbcExceptionDialog === null || showGenericOnLmbcExceptionDialog === void 0 ? void 0 : showGenericOnLmbcExceptionDialog.medicinalProductPackPbsDetail));
            }, onSearch: function () { return updateSearchValues(showGenericOnLmbcExceptionDialog.medicinalProductPack.name); } })),
        React.createElement(StyledDialog, { open: true, size: 'lg', modal: true, testId: 'medication-browser', title: 'Medication browser', headerExtraContents: React.createElement(DecisionSupportWarningAlert, { noBorder: true }), preventSideBarCollapse: true, sidePanelSize: SidePanelSizes.Small, sidebarRender: function () {
                return React.createElement(MedicationsBrowserFilter, __assign({}, filterState));
            }, titleBarRight: React.createElement(Tooltip, { title: 'Close' },
                React.createElement(Button, { iconOnly: true, onClick: props.onCancel, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-medication-browser-dialog' },
                    React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true }))), actions: actionButtons, contentComponent: React.createElement(StyledDialogContent, { noPadding: true },
                React.createElement("div", { className: styles.container },
                    React.createElement(MedicationBrowserPacksList, { allowFreeTextMedication: allowFreeTextMedication, limit: filterState.state.limit, loadCount: medicationPacksAsync.loadCount, products: medicationPacks, onSelect: setSelectedMedication, freeText: freeTextMedicationName, onEditFreeText: setFreeTextMedicationName, selectedItem: selectedMedication, onSetExpandedIds: setExpandedMedicationIds, expandedItemIds: expandedMedicationIds, loadStatus: medicationPacksAsync.status }))) })));
};
